"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Checkbox = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const react_aria_1 = require("react-aria");
const react_stately_1 = require("react-stately");
const CheckboxBase_1 = require("./CheckboxBase");
function Checkbox(props) {
    const { label, disabled: isDisabled = false, selected, ...otherProps } = props;
    // Treat indeterminate as false so that clicking on indeterminate always goes --> true.
    const isSelected = selected === true;
    const isIndeterminate = selected === "indeterminate";
    const ariaProps = { isSelected, isDisabled, isIndeterminate, ...otherProps };
    const checkboxProps = { ...ariaProps, "aria-label": label };
    const ref = (0, react_1.useRef)(null);
    const toggleState = (0, react_stately_1.useToggleState)(ariaProps);
    const { inputProps } = (0, react_aria_1.useCheckbox)(checkboxProps, toggleState, ref);
    return ((0, jsx_runtime_1.jsx)(CheckboxBase_1.CheckboxBase, { ariaProps: ariaProps, isDisabled: isDisabled, isIndeterminate: isIndeterminate, isSelected: isSelected, inputProps: inputProps, label: label, ...otherProps }));
}
exports.Checkbox = Checkbox;
